import { initialState } from "../reducers/root.reducer";
import { IUser } from "../../models/user.interface";
import { UserAction } from "../actions/user.actions";
import { UserActionTypes } from "../actions/types";

export const userReducer = (
  state: IUser | null = initialState.user,
  action: UserAction
) => {
  switch (action.type) {
    case UserActionTypes.CHECK_RELATED_POLICIES:
      return action.payload;
    case UserActionTypes.GET_MINIMUM_START_DATE:
      return action.payload;      
    default:
      return state;
  }
};
